import React, { useMemo } from 'react'
import { View } from 'react-native'
import Svg, { Path } from 'react-native-svg'
import { getBundledMap } from '../lib/bundledMaps'

/** Shared map context for local design galleries. */
export function ConceptMiniMap({ dark, height = 135 }: { dark: boolean; height?: number }) {
  const map = useMemo(() => getBundledMap('minnesota')!, [])
  const colors = ['#b82020', '#b82020', '#b82020', '#2356bd', '#73777c', '#8253a2', '#317a51']
  return <View style={{ height, backgroundColor: dark ? '#303923' : '#f4ecd3', alignItems: 'center', padding: 5 }}>
    <Svg width="100%" height="100%" viewBox={`0 0 ${map.viewBox.width} ${map.viewBox.height}`}>
      {map.territories.map((territory, index) => <Path key={territory.id} d={territory.shape} fill={colors[index % colors.length]} stroke={dark ? '#303923' : '#f4ecd3'} strokeWidth={0.6} />)}
    </Svg>
  </View>
}
